// Editor is the main app component that builds the full page.

import CopyTileController from 'app/src/editor/CopyTileController';
import EditorView from 'app/src/editor/EditorView';
import MapStoreController from 'app/src/editor/MapStoreController';
import { PluginsContextProvider } from 'app/src/editor/PluginsContext';
import TileHoverController from 'app/src/editor/TileHoverController';
import TileInteractionModeController from 'app/src/editor/TileInteractionModeController';
import UndoRedoController from 'app/src/editor/UndoRedoController';
import ModalContainerController from 'app/src/modals/ModalContainerController';
import GamePluginLoader from 'app/src/plugins/GamePluginLoader';
import * as React from 'react';

export default function Editor(): React.ReactElement {
	const plugins = new Set([
		GamePluginLoader.sharedInstance.loadPlugin('EmptyFloorGamePlugin'),
		GamePluginLoader.sharedInstance.loadPlugin('GearsGamePlugin'),
		GamePluginLoader.sharedInstance.loadPlugin('ConveyorsGamePlugin'),
		GamePluginLoader.sharedInstance.loadPlugin('PitsGamePlugin'),
	]);

	return (
		<PluginsContextProvider value={plugins}>
			<ModalContainerController>
				<CopyTileController>
					<MapStoreController>
						<TileHoverController>
							<TileInteractionModeController>
								<UndoRedoController>
									<EditorView />
								</UndoRedoController>
							</TileInteractionModeController>
						</TileHoverController>
					</MapStoreController>
				</CopyTileController>
			</ModalContainerController>
		</PluginsContextProvider>
	);
}
